export const ADD_PRODUCT = {}
export const ADD_OPEN_VALUE_PRODUCT = {}
export const REMOVE_PRODUCT = {}
export const EMPTY_BASKET = {}
export const UPDATE_LOCATION = {}
export const UPDATE_STOCK = {}

export function addToBasket(uuid) {
  return {
    type: ADD_PRODUCT,
    uuid
  }
}

export function addOpenValueToBasket(uuid, value) {
  return {
    type: ADD_OPEN_VALUE_PRODUCT,
    uuid,
    value
  }
}

export function removeFromBasket(uuid) {
  return {
    type: REMOVE_PRODUCT,
    uuid
  }
}

export function emptyBasket() {
  return {
    type: EMPTY_BASKET
  }
}

export function updateStock(stock) {
  return {
    type: UPDATE_STOCK,
    stock
  }
}

export function updateCinemaLocation(cinemaLocation) {
  return {
    type: UPDATE_LOCATION,
    cinemaLocation
  }
}
